import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

import { Sizes } from './types';

export const Container = styled.div<{ $size: Sizes; $canCollapse: boolean }>`
  display: flex;
  justify-content: space-between;

  margin: ${({ theme }) =>
    `${theme.spacing(0)} ${theme.spacing(5)} ${theme.spacing(1)} ${theme.spacing(5)}`};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ $size, theme }) =>
    $size === Sizes.Small &&
    css`
      color: ${theme.palette.text.secondary};
    `}
`;

const TitleStyle = css`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;

  margin: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(0)}`};
  color: inherit;
`;

export const CollapseButton = styled.button`
  ${TitleStyle};
  margin: 0;
  padding: 0;

  background: transparent;
  border: none;

  cursor: pointer;
  line-height: 1;
`;
export const TitleContainer = styled.span`
  ${TitleStyle};
`;

export const IconButtonContainer = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const TitleCount = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  color: inherit;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;
